document.addEventListener('DOMContentLoaded', function() {
  // Original functionality
  const columns = document.querySelectorAll('.special-deals-column');
  const footer = document.querySelector('.special-deals-footer');
  
  // Add click tracking or analytics if needed
  columns.forEach(column => {
    column.addEventListener('click', function(e) {
      if (e.target.tagName !== 'A' && e.target.tagName !== 'BUTTON') {
        const button = column.querySelector('.column-button');
        if (button) {
          button.click();
        }
      }
    });
  });

  // Side Drawer Functionality
  const drawerOverlay = document.getElementById('sideDrawerOverlay');
  const drawerClose = document.getElementById('drawerClose');
  const drawerTitle = document.getElementById('drawerTitle');
  const drawerDescription = document.getElementById('drawerDescription');
  const drawerButton = document.getElementById('drawerButton');
  const drawerTriggers = document.querySelectorAll('.drawer-trigger');

  // Open drawer when clicking underlined links
  drawerTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get data attributes
      const heading = this.getAttribute('data-drawer-heading') || 'Get 15% Off First Online Order';
      const description = this.getAttribute('data-drawer-description') || 'Thank you for choosing us! As a token of our appreciation, enjoy a 15% discount on your first online order.';
      const buttonText = this.getAttribute('data-drawer-button-text') || 'Shop Now';
      const buttonUrl = this.getAttribute('data-drawer-button-url') || '#';
      
      // Update drawer content
      drawerTitle.textContent = heading;
      drawerDescription.innerHTML = `<p>${description}</p>`;
      drawerButton.textContent = buttonText;
      drawerButton.href = buttonUrl;
      
      // Show drawer
      drawerOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  // Close drawer functions
  function closeDrawer() {
    drawerOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  drawerClose.addEventListener('click', closeDrawer);
  
  drawerOverlay.addEventListener('click', function(e) {
    if (e.target === drawerOverlay) {
      closeDrawer();
    }
  });

  // Close drawer on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawerOverlay.classList.contains('active')) {
      closeDrawer();
    }
  });

  // Responsive adjustments based on screen size
  function adjustLayout() {
    const grid = document.querySelector('.special-deals-grid');
    const isMobile = window.innerWidth < 768;
    
    if (isMobile) {
      grid.style.gridTemplateColumns = '1fr';
    } else {
      grid.style.gridTemplateColumns = 'repeat(3, 1fr)';
    }
  }

  // Initial adjustment
  adjustLayout();
  
  // Adjust on window resize
  window.addEventListener('resize', adjustLayout);
});